export default __webpack_public_path__ + "static/media/funbiz.7e60f9d8.png";